var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIExt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 3.33325C23.94 3.33325 25.7828 5.17612 25.7828 7.44941L25.7817 8.33325H31.6667C32.5871 8.33325 33.3333 9.07944 33.3333 9.99992L33.3317 15.8316L30.7828 15.8333C28.6005 15.8333 26.8148 17.5316 26.6754 19.6788L26.6667 19.9494V20.0504C26.6667 22.2328 28.3651 24.0185 30.5122 24.1578L30.7828 24.1666L33.3317 24.1649L33.3333 30.0048C33.3333 30.9253 32.5871 31.6715 31.6667 31.6715L25.7817 31.6699L25.7828 32.5504C25.7828 34.8237 23.94 36.6666 21.6667 36.6666C19.3934 36.6666 17.5505 34.8237 17.5505 32.5504L17.55 31.6699L11.6667 31.6715C10.7462 31.6715 10 30.9253 10 30.0048L9.99833 24.1183L9.11616 24.1185C6.84287 24.1185 5 22.2757 5 20.0024C5 17.7291 6.84287 15.8862 9.11616 15.8862L9.99833 15.8849L10 9.99992C10 9.07944 10.7462 8.33325 11.6667 8.33325H17.55L17.5505 7.44941C17.5505 5.17612 19.3934 3.33325 21.6667 3.33325Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIExt);
export default __webpack_public_path__ + "static/media/i-ext.0d8346f5.svg";
export { ForwardRef as ReactComponent };